export const parseElectionDatetime = (electionDatetime: string | null | undefined): Date | null => {
    if (!electionDatetime) {
        return null
    }

    const [datePart, timePart] = electionDatetime.split(" ")

    if (!datePart || !timePart) {
        return null
    }

    const [year, month, day] = datePart.split("-").map(Number)
    const [hours, minutes, seconds] = timePart.split(":").map(Number)

    const parsedDate = new Date(year, month - 1, day, hours, minutes, seconds)

    if (Number.isNaN(parsedDate.getTime())) {
        return null
    }

    return parsedDate
}
